<section class='bin-management'>
  <div class="bin-header-container">
    <label class="basic-label">{{data?.binData?.binHeader}}</label>
    <i class="close-icon icon-requisition-denied" (click)="closeBottomSheet($event)"></i>
  </div>
  <div class="bin-container">
    <div class="bin-transaction">
      <label class="basic-label">{{data?.binData?.binTransactionHeader}}</label>
      <label class="bin-label">{{data?.binData?.binTransactionNumber}}</label>
    </div>
    <div class="body-bin-details">
      @for (binTransaction of data.binData.binTransactiondetails; track binTransaction) {
        <div class="bin-data">
          <label class="basic-label">{{binTransaction.Label}}</label>
          <label class="bin-label">{{binTransaction.Value}}</label>
        </div>
      }
    </div>
    <div class="bin-details-container">
      <div>
        <label class="bin-details">{{data?.binData?.binDetailsHeader}}</label>
      </div>
      <div class="bin-data">
        <label class="bin-details-label">{{data?.binData?.binQuantityLabel}}</label>
        <label class="bin-details">{{data?.binData?.binQuantity}}</label>
      </div>
    </div>
    @for (index of [0,1,2,3,4]; track index) {
      <div class="bin-management-details">
        <div class="body-bin-label">
          <label class="bincode">{{data.binData.binDetails.binCode}}</label>
          <label class="binid">{{data.binData.binDetails.binId}}</label>
          <label class="icon-icon-plus">{{data.binData.binDetails.binWeight}}</label>
        </div>
        <div class="body-bin-qty">
          <label class="bin-bottom-label">{{data.binData.binDetails.binQOH}}</label>
          <input class="bin-input">
        </div>
      </div>
    }
  </div>
</section>